import type { AgendaSettings } from "@bookdental/schemas";
import { APPOINTMENT_STATUS_COLORS, type AppointmentStatus } from "@bookdental/schemas";

/** Paleta "assorted" (hash determinístico do nome → cor) — 16 cores. */
const ASSORTED_PALETTE = [
  "#1D4ED8", // azul escuro
  "#06B6D4", // cyan
  "#10B981", // emerald
  "#F59E0B", // amber
  "#EF4444", // red
  "#EC4899", // pink
  "#3B82F6", // blue
  "#14B8A6", // teal
  "#F97316", // orange
  "#84CC16", // lime
  "#0F766E", // teal escuro
  "#64748B", // ardósia
  "#E11D48", // rose
  "#0EA5E9", // sky
  "#22C55E", // green
  "#EAB308", // yellow
];

/** Hash simples de string → índice. */
function hashToIndex(s: string, mod: number): number {
  let h = 0;
  for (let i = 0; i < s.length; i++) {
    h = (h << 5) - h + s.charCodeAt(i);
    h |= 0;
  }
  return Math.abs(h) % mod;
}

/**
 * Resolve a cor base de um appointment dado o cardStyle.
 * Prioridade: `appointment.color` (override manual) > cardStyle.
 */
export function resolveCardColor(
  appointment: { status: AppointmentStatus; color?: string | null; patientName: string },
  cardStyle: AgendaSettings["cardStyle"],
): string {
  if (appointment.color) return appointment.color;

  switch (cardStyle) {
    case "light":
      return "#5BA3D9";
    case "assorted":
      return ASSORTED_PALETTE[hashToIndex(appointment.patientName, ASSORTED_PALETTE.length)];
    // Todos os outros estilos (colorful + os 5 novos: bordered, solid, minimal,
    // outlined, sticker) usam a cor semântica do status. O que muda entre eles
    // é a ESTÉTICA de aplicação dessa cor — implementada em getCardStyleSpec.
    case "colorful":
    case "bordered":
    case "solid":
    case "minimal":
    case "outlined":
    case "sticker":
    default:
      return APPOINTMENT_STATUS_COLORS[appointment.status] ?? "#3B82F6";
  }
}
